export const
    TL_MODE = { v: 'VERTICAL', va: 'VERTICAL_ALTERNATING', h: 'HORIZONTAL' },
    URL_APPEND = '', // 'http://localhost:8000',

    reactSelectStyles = {
        option: (styles, state) => ({
            ...styles,
            cursor: 'pointer',
        }),
        control: (styles) => ({
            ...styles,
            minWidth: '200px',
            cursor: 'pointer',
        }),
    }